import { useEffect, useState } from "react";
import { AiOutlineEye } from "react-icons/ai";
import { FaEdit, FaTrash } from "react-icons/fa";
import { BsFileEarmarkPdf } from "react-icons/bs";
import PostApiCall from "../Api/PostApi";
import { LeadsTable } from "./LeadsTable";
import Dropdown from "react-bootstrap/Dropdown";
import Notiflix from "notiflix";
import LeadsUpdates from "./LeadsUpdates";
import LeadsDeleteModal from "./LeadsDeleteModal";

export const VisitorLeadsList = () => {
	const [visitorDetails, setVisitorDetails] = useState([]);

	// const [currentPage, setCurrentPage] = useState(1);
	// const [pageSize, setPageSize] = useState(10);
	// const [disableNext, setDisableNext] = useState(false);


	//For filter data
	const [filteredVisitorDetails, setFilteredVisitorDetails] = useState([]);
	const [selectedWebsite, setSelectedWebsite] = useState("");

	const [filtersList, setFiltersList] = useState([]);

	// 
	const [isModalOpen, setIsModalOpen] = useState(false);
	const handleCloseModal = (type = '') => {
		setIsModalOpen(false);
		setSelectedData({});
		setSelectedType('');
		if (type === 'fetch') {
			GetUpdatedVisitorLeads();
			GetVisitorLeadsFilter();
		}
	}
	const [selectedType, setSelectedType] = useState('');
	const [selectedData, setSelectedData] = useState({});

	const [selectedFilter, setSelectedFilter] = useState([]);
	const [selectedFilterValue, setSelectedFilterValue] = useState([]);

	// delete modal
	const [isDeleteOpen, setIsDeleteOpen] = useState(false);
	const handleCloseDeleteModal = (type = '') => {
		setIsDeleteOpen(false);
		setSelectedData({});
		setSelectedType('');
		if (type === 'fetch') {
			GetUpdatedVisitorLeads();
			GetVisitorLeadsFilter();
		}
	}

	useEffect(() => {
		GetUpdatedVisitorLeads();
		GetVisitorLeadsFilter();
	}, []);
	const GetUpdatedVisitorLeads = (value = '', page = 1, pageSize = 10) => {
		if (!value) {
			setSelectedFilter([]);
			setSelectedFilterValue([]);
		}
		Notiflix.Loading.dots("Please Wait...");
		PostApiCall.postRequest(
			{
				whereClause: value ? `where ${value}` : '',
				page,
				pageSize
			},
			"GetUpdatedVisitorLeads"
		).then((results) =>
			results.json().then((obj) => {
				Notiflix.Loading.remove();
				if (results.status === 200 || results.status === 201) {
					// if (obj?.data?.length < pageSize) {
					// 	setDisableNext(true);
					// } else {
					// 	setDisableNext(false);

					// }
					setVisitorDetails(obj.data);
					setFilteredVisitorDetails(obj.data);

					// setCurrentPage(obj.page);
					// setPageSize(obj.pageSize);
				}
			})
		);
	};
	const GetVisitorLeadsFilter = () => {
		PostApiCall.postRequest({ whereClause: '' },
			"GetVisitorLeadsFilter").then((results) =>
				results.json().then((obj) => {
					if (results.status == 200 || results.status == 201) {
						setFiltersList(obj.data);
					}
				})
			);
	}

	const sortVisitorList = (field, order) => {
		const listToFilter = [...visitorDetails]; // clone to avoid mutating state

		const sortedList = listToFilter.sort((a, b) => {
			let valA = a[field];
			let valB = b[field];

			// Handle string comparison
			if (typeof valA === "string" && typeof valB === "string") {
				return order === "Asc"
					? valA.localeCompare(valB)
					: valB.localeCompare(valA);
			}

			// Handle numbers/dates
			return order === "Asc" ? valA - valB : valB - valA;
		});

		setFilteredVisitorDetails(sortedList);
	};



	const Visitordata = {
		columns: [
			{
				label: "S No.",
				field: "SNo",
				sort: "asc",
				width: 30,
			},
			{
				label: "Full Name",
				field: "FullName",
				sort: "asc",
				width: 30,
			},
			{
				label: "Email Address",
				field: "EmailAdd",
				sort: "asc",
				width: 50,
			},
			{
				label: "Mobile",
				field: "Mobile",
				sort: "asc",
				width: 50,
			},
			{
				label: "Country",
				field: "countryandcode",
				sort: "asc",
				width: 50,
			},
			{
				label: "Lead Status",
				field: "leadstatus",
				sort: "asc",
				width: 50,
			},
			{
				label: "Timeline to Invest",
				field: "timeline",
				sort: "asc",
				width: 50,
			},
			{
				label: "Budget",
				field: "budget",
				sort: "asc",
				width: 50,
			},
			{
				label: "Action",
				field: "action",
				sort: "asc",
				width: 50,
			},

		],
		rows: filteredVisitorDetails?.map((data, i) => {
			return {
				SNo: (i + 1),

				FullName: `${data?.fld_first_name} ${data?.fld_last_name}`,

				EmailAdd: `${data?.fld_email_address}`,
				Mobile: `${data?.fld_mobile_number}`,

				countryandcode: `${data?.fld_country} `,

				countryandcode_display: (
					<p>{data?.fld_country} ({data?.fld_country_code})</p>
				),
				leadstatus: data?.fld_leads_status,
				timeline: data?.fld_timeline_to_invest,

				budget: data?.budget,

				action: <div className="d-flex align-items-center gap-1">
					<AiOutlineEye onClick={() => {
						setSelectedData(data);
						setSelectedType('View'); setIsModalOpen(true);
					}} />
					<FaEdit onClick={() => {
						setSelectedData(data);
						setSelectedType('Edit'); setIsModalOpen(true);
					}} />
					<FaTrash onClick={() => {
						setSelectedData(data);
						setIsDeleteOpen(true);
					}} />
				</div>,
			};
		}),
	};

	// const handlePageChange = (page, value = '') => {
	// 	setCurrentPage(page);
	// 	GetUpdatedVisitorLeads(value, page, pageSize);
	// };

	// const handlePageSizeChange = (size, value = '') => {
	// 	setPageSize(size);
	// 	setCurrentPage(1);
	// 	GetUpdatedVisitorLeads(value, 1, size);
	// };
	return (
		<div className="position-relative visitor-leads-filter">
			<LeadsTable type="Visitor Registration List"
				selectedFilter={selectedFilter} setSelectedFilter={setSelectedFilter}
				selectedFilterValue={selectedFilterValue} setSelectedFilterValue={setSelectedFilterValue}
				data={Visitordata} sortVisitorList={sortVisitorList}
				filtersList={filtersList}
				GetUpdatedVisitorLeads={GetUpdatedVisitorLeads}
				setIsModalOpen={setIsModalOpen}
				allLeadsList={filteredVisitorDetails}
			// currentPage={currentPage}
			// pageSize={pageSize}
			// onPageChange={handlePageChange}
			// onPageSizeChange={handlePageSizeChange}
			// disableNext={disableNext}
			/>

			{/* modal form */}
			<LeadsUpdates isModalOpen={isModalOpen}
				handleCloseModal={handleCloseModal}
				selectedType={selectedType}
				selectedData={selectedData}
			/>
			{/* detail delete modal */}
			<LeadsDeleteModal
				selectedData={selectedData}
				isDeleteOpen={isDeleteOpen}
				handleCloseDeleteModal={handleCloseDeleteModal}
			/>
		</div>
	);
};
